// Slick carousel settings across entire site
export default ($) => {
    let _alertBox      = $('.site-alert-bars');
    let _alertTrigger  = $('.js-alert-trigger');
    let _submenus      = $('.js-submenus');
    let initialTop     = 120; // This is magic number - TOP position for .submenus without any alert.
    let scrolledTop    = 68;
    let _alertHeight   = _alertBox.outerHeight();
    let _realCount     = 0;
    let _body          = $('body');
    let _disabledAlert = _body.hasClass('js-no-alerts');

    if (_disabledAlert)
        return;

    count();

    _alertTrigger.on('click', function () {
        console.log('test');
        let _alert = $(this).closest('.js-alert-bar');
        _alert.toggleClass('active');

        count();
    });

    $(document).on('resize', function () {
        count();
    });

    $(window).on('scroll', function () {
        count();
    });

    function count() {
        _realCount = bodyScrolled() ? scrolledTop : initialTop;
        _alertHeight = _alertBox.outerHeight();
        _submenus.css('top', _alertHeight + _realCount);
    }

    function bodyScrolled() {
        return _body.hasClass('slideUp');
    }
}